import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { DeckWithCard, MatchingCardInDeck } from "./magic-card-in-decks.component";
import { styleDeckElementBackgroundSmall } from "@ponder-features/user/decks/deck-utils";
import { getDeckRoute } from "@ponder-features/user/decks/deck-router";
import { NgClass } from "@angular/common";
import { getMagicCardRoute2 } from "./magicCardRouter";
import { environment } from "../../../../environments/environment";

@Component({
    selector: "magic-card-in-deck-row",
    imports: [NgClass],
    templateUrl: "./magic-card-in-decks-row.component.html"
})
export class MagicCardInDecksRowComponent implements AfterViewInit {
    @Input({ required: true }) public deckWithCard!: DeckWithCard;
    @Input({ required: true }) public username!: string;
    @Input({ required: true }) public thisCardId!: string;

    @ViewChild("titleOuter") private titleOuterRef!: ElementRef<HTMLDivElement>;
    @ViewChild("titleInner") private titleInnerRef!: ElementRef<HTMLDivElement>;
    @ViewChild("versionTooltip") private versionTooltipRef!: ElementRef<HTMLElement>;

    public deckUrl!: string;

    public ngOnInit(): void {
        this.deckUrl = getDeckRoute(this.username, this.deckWithCard.deckId);
    }

    public ngAfterViewInit(): void {
        styleDeckElementBackgroundSmall(
            this.titleOuterRef.nativeElement,
            this.titleInnerRef.nativeElement,
            this.deckWithCard.deckColor,
            this.deckWithCard.backgroundCardId);
    }

    public isFocusedCard(cardId: string): boolean {
        return (cardId == this.thisCardId);
    }

    public getCardUrl(card: MatchingCardInDeck): string {
        return getMagicCardRoute2(card.cardName, card.setCode, card.setIndex);
    }

    public onVersionHover(cardId: string): void {
        this.versionTooltipRef.nativeElement.style.setProperty("background-image", `url("${environment.ponderImageBaseUrl}/card/small/front/${cardId}.jpg")`);
        this.versionTooltipRef.nativeElement.classList.remove("invisible");
    }

    public onVersionStopHover(): void {
        this.versionTooltipRef.nativeElement.classList.add("invisible");
    }
}